import React from "react";
import { useEffect, useState } from "react";

import axios from "axios";
import "react-phone-input-2/lib/style.css";
import { countries } from "../../components/select/src/data/countries";
import PhoneInput from "../../components/tel/phone-input2/src/index";
import rawCountries from "../../components/tel/phone-input2/src/rawCountries";
import { API_ENDPOINTS } from "../../util/constants";
export const TelInput = (props) => {
  const [savedCountry, setSavedCountry] = useState();
  const [preSelectedCountry, setPreSelectedCountry] = useState("");

  useEffect(() => {
    if (!customer_number && !props.country) {
      getLastSavedCountry();
    }
  }, []);

  useEffect(() => {
    if (props.country) {
      setPreSelectedCountry(
        rawCountries.find(
          (val) => val[3] === props.country.slice(1)
        )[2]
      );
    }
  }, [props.country])

  const getLastSavedCountry = async () => {
    const { data } = await axios.get(API_ENDPOINTS.getLastSavedCountryCode);
    setSavedCountry(data);
  };

  const [customer_number, setCustomerNumber] = useState(
    props.ticker_initial_customer_number
      ? props.ticker_initial_customer_number
      : ""
  );
  const customLabels = {};

  Object.keys(countries).map((code) => {
    customLabels[code] = { primary: code, secondary: "" };
  });

  useEffect(() => {
    if (
      props.ticker_initial_customer_number && (props.moduleName === "c2c_ticker" || props.moduleName === 'agent_settings')
    ) {
      setCustomerNumber(props.ticker_initial_customer_number);
    }
  }, [props.ticker_initial_customer_number]);

  useEffect(() => {
    if (savedCountry && savedCountry.countryCode)
    try { 
      setPreSelectedCountry(
        rawCountries.find(
          (val) => val[3] === savedCountry.countryCode.slice(1)
        )[2]
      );
      } catch(e) {
        // avoiding country code differences in old and new sr
        setSavedCountry({ country: "in",  countryCode : "+91" });
      }
  }, [savedCountry]);

  return (
    <div className="row tel-select" style={{ width: "-webkit-fill-available" }}>
      <div className="col-12 flex-d">
        <PhoneInput
          searchPlaceholder={"Search Country"}
          country={savedCountry && savedCountry.country ? savedCountry.country : preSelectedCountry}
          enableSearch={true}
          disableSearchIcon={true}
          disableCountryGuess={true}
          disableCountryCode={true}
          value={customer_number}
          validStatus={props.status}
          readOnly={props.readOnly}
          startAdornment={props.startAdornment}
          showValidationMessage={props.showValidationMessage}
          label={props.label}
          onChange={(phone, countryData) => {
            if (!countryData) return;
            setCustomerNumber(phone);
            props.onEvent({
              type: "c2c_form::set",
              key: "customer_number",
              value: "+" + countryData.dialCode + phone,
              ...(props?.moduleName == 'agent_settings' && { country_code: countryData.dialCode })
            });
          }}
          onBlur={props.onHanleBlur}
          inputClass={"abc"}
          componentType={props.componentType}
          containerClass={"c2c-tel"}
          buttonClass={"c2c-tel-btn"}
          buttonStyle={{
            position: "relative",
            float: "left",
            marginRight: "10px",
            borderRadius: "4px",
            border: "1px solid #1f4a94",
            backgroundColor: "#FFF",
            display: "flex",
            alignItems: "center",
            minWidth: "65px",
            width: "79px",
            height: "48px",
            justifyContent: "center",
          }}
          inputStyle={{
            paddingLeft: "14px",
            border: "1px solid #ccd6e3",
            height: "51px",
          }}
          inputProps={{
            name: "phone",
            required: true,
            autoFocus: true,
          }}
        />
      </div>
    </div>
  );
};